/**
 * isColumnTypeId
 *
 * The dot test the four FLAT source positions in the derive subsystem are
 * judged by: `colAggregate.typeId`, a projection's partition key
 * `source.typeId`, `groupAggregate.typeId` and `rowReferenceProp.referenceTypeId`.
 * For the two positions that may address a composite sub-field — a projection's
 * declared column and a column arm's `sourceCell.typeId` — see
 * `isColumnPathTypeId`. Consumers: `createFormDeriveEngineConfig` (drops a dotted
 * source on those four positions) and the Derived values drawer's source universe,
 * which must not OFFER what the config validator would drop — a second spelling
 * there authors entries that vanish on save with nothing to explain it. A typeId
 * addressing a whole column, never a composite sub-field: everywhere else in the
 * ArTable system a dot means "sub-field" — `arFormulaTargetFieldSegments` maps
 * `price.margin` to `cells.price.value.fields.margin.value`, and
 * `detectFormDeriveCycle` collapses it to its root column — but each of these
 * four reads is flat, `cells['price.margin']`, which never exists, so a dotted
 * typeId is REJECTED rather than root-collapsed: a partition key and a
 * `groupAggregate` fold whole cells, and `rowReferenceProp` does the composite
 * hop explicitly instead. `colAggregate.aggregationFieldPath` is the sanctioned
 * composite path and is left alone — `computeColumnAggregation` resolves it.
 */

function isColumnTypeId(value: unknown): value is string {
  return typeof value === 'string' && value !== '' && !value.includes('.');
}

export { isColumnTypeId };
